import { render, staticRenderFns } from "./mationDialog.vue?vue&type=template&id=52781dff&scoped=true"
import script from "./mationDialog.vue?vue&type=script&lang=js"
export * from "./mationDialog.vue?vue&type=script&lang=js"
import style0 from "./mationDialog.vue?vue&type=style&index=0&id=52781dff&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52781dff",
  null
  
)

export default component.exports